var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPessoasWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.41,
    height: 16.115,
    transform: "translate(0 0)",
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.795 4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,0H7A4,4,0,1,1,3,4,4,4,0,0,1,7,0",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.69,9H5.03A5.027,5.027,0,0,0,0,14.03c0,2.78,13.72,2.78,13.72,0A5.027,5.027,0,0,0,8.69,9",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.27,3.45a3.141,3.141,0,0,1-3.14,3.14,6.766,6.766,0,0,1-.84-.12.174.174,0,0,1-.1-.189l0-.011a5.064,5.064,0,0,0,.39-1.95A5.186,5.186,0,0,0,11.45,1.1l-.02-.02a.221.221,0,0,1-.05-.14.184.184,0,0,1,.05-.12.34.34,0,0,1,.1-.06,2.987,2.987,0,0,1,1.6-.45,3.145,3.145,0,0,1,3.14,3.14",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.41,11.33c0,.74-1.22,1.23-2.84,1.46a.492.492,0,0,1-.54-.37A6.286,6.286,0,0,0,11.3,8.24a.431.431,0,0,1-.086-.047.206.206,0,0,1-.11-.18.253.253,0,0,1,.06-.15,5.477,5.477,0,0,0,.376-.423.182.182,0,0,1,.14-.06h2.78a3.952,3.952,0,0,1,3.95,3.95",
    fill: "#eee"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPessoasWhite);
export default __webpack_public_path__ + "static/media/pessoas - white.aa401d3300b7ee180767b4bc5f765c19.svg";
export { ForwardRef as ReactComponent };